import React, { useContext, useEffect, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import Radio from '@react/react-spectrum/Radio'
import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'
import Button from '@react/react-spectrum/Button'
import Wait from '@react/react-spectrum/Wait'
import Well from '@react/react-spectrum/Well'
import Select from '@react/react-spectrum/Select'
import Checkbox from '@react/react-spectrum/Checkbox'
import Link from '../Nav/Link'
import Alert from '@react/react-spectrum/Alert'
import { error } from '@react/react-spectrum/Toast'
import '../../style/console.css'
import CredInfo from './CredInfo'
import ErrorMsg from './ErrorMsg'
import ConsoleSteps from './ConsoleSteps'
import Ps from '../../asset/img/ps.svg'

import {
    runCreateCredentialsServicePrincipal,
    acceptTerms,
    getDate
} from '../../lib/consoleApi'
import {
    setBodyHeight,
    createRecaptchaElement,
    runRecaptcha,
    logMsg,
    getAwsMarketplaceUser,
    setAwsMarketplaceUser,
    goToUrlTarget,
    pUserInfo
} from '../../lib/easybake'
import {
    TIMEOUT_TOAST_FAIL, 
    STATUS_CODE_FAIL_LEGAL,
    STATUS_CODE_FAIL_FORBIDDEN,
    STATUS_CODE_SUCCESS_OK,
    STATUS_CODE_SUCCESS_CREATED,
    STATUS_CODE_FAIL_CONFLICT,
    CONSOLE_PROJECT_NAME_PATTERN
} from '../../lib/constants'

export default function Create (props) {
    const { referrer } = props || {}
    const { 
        dispatch,
        projectName,
        cred,
        wait,
        page,
        ut,
        userOrgs,
        formCompanySize,
        formFullName,
        formEmail,
        formCompany,
        formRole,
        formUseCase,
        formAgreement,
        formDevTermsAgreement,
        act,
        awsCustomerId,
        awsProdCode,
        awsCustomerClientId,
        dMode
     } = useContext(EasybakeContext)

     const [ projectNameErrorMsg, setProjectNameErrorMsg ] = useState(null)
     const uInfo = [
        { name: __('signup_form_name'), value: formFullName },
        { name: __('signup_form_email'), value: formEmail },
        { name: __('signup_form_company'), value: formCompany },
        { name: __('signup_form_role'), value: formRole },
        // { name: __('signup_form_company-size'), value: getSelectedValue(formCompanySize) },
        { name: __('signup_form_company-size'), value: '' },
        { name: __('signup_form_usecase'), value: formUseCase },
        // { name: __('signup_form_agreement'), value: formAgreement }
        { name: __('signup_form_agreement'), value: '' }
    ]
    let modal = null
    let accepted = false

    useEffect(() => {
        setVariables()
        runAwsMarketplaceUser()
        createRecaptchaElement()
        setProjectNameErrorMsg()
        setUserOrgs()
        dispatch({ type: 'set-projectName', payload: { projectName: `Project ${getDate()}` } })
        dispatch({ type: 'set-cred', payload: { cred: null } })
        dispatch({ type: 'set-formDevTermsAgreement', payload: { formDevTermsAgreement: false } })
        setBodyHeight('adobe-easybake-main-sub-pane')
        setProfile()
    }, [userOrgs, awsCustomerId])

    async function setProfile() {
        if (!formFullName || !formEmail) {
            if (window.easybake) {
                const profile = await window.easybake.parent.getIMSProfile()
                dispatch({ type: 'set-formFullName', payload: { formFullName: profile.name } })
                dispatch({ type: 'set-formEmail', payload: { formEmail: profile.email } })
            }
        }
    }

    async function acceptDevTerms(e) {
        try {
            const selectedUserOrg = userOrgs.data.filter( org => org.selected)[0]
            const terms = await acceptTerms(ut, selectedUserOrg.id)
            if (terms && terms.error) {
                throw new Error(terms.error)
            } else if (terms && terms.response && terms.response.data && terms.response.data.accepted) {
                await createCredentials()
                return
            } else {
                logAlert(null, terms && terms.response && terms.response.status || 'unknown')
            }
        } catch(e) {
            logAlert(e)
            analytics.sendEventName('click', `${page}:consoledevterms:error`)
        }
    }

    function setVariables() {
        if (referrer && !awsCustomerId) {
            dispatch({ type: 'set-awsCustomerId', payload: { awsCustomerId: referrer.awsCustomerId } })
            dispatch({ type: 'set-awsProdCode', payload: { awsProdCode: referrer.awsProdCode } })
        }
    }

    function signInClick() {
        if (window.easybake) {
            window.easybake.parent.signIn()
        }
    }

    async function runAwsMarketplaceUser() {
        if (page !== 'awsmp' || awsCustomerClientId) {
            return
        }
        try {
            if (ut && awsCustomerId && !awsCustomerClientId) {
                const res = await getAwsMarketplaceUser(ut, awsCustomerId)
                if (res.error) {
                    error(`${__('msg_error_general')}`, {
                        timeout: TIMEOUT_TOAST_FAIL
                    })
                } else {
                    const data = await res.response.json()
                    if (data.clientId) {
                        let newClientId = data.clientId
                        if (data.clientId.match(/FAIL/)) {
                            newClientId = ''
                        }
                        dispatch({ type: 'set-awsCustomerClientId', payload: { awsCustomerClientId: newClientId } })
                    }
                }
            }
        } catch(e) {
            logAlert(e)
        }
    }

    async function setUserOrgs() {
        const statusCode = userOrgs && userOrgs.status || null
        let err = null
        if (!statusCode) {
            err = 'FAILED to get org'
        } else if (statusCode === STATUS_CODE_SUCCESS_OK) {
            if (userOrgs.data && userOrgs.data.length > 0) {
                dispatch({ type: 'set-userOrgs', payload: { userOrgs: userOrgs }})
            } else {
                err = `FAILED to get org: ${userOrgs.data && userOrgs.data.length}.  This user may not have Admin/Dev role.`
            }
        } else {
            err = `FAILED to get org: ${statusCode}`
        }
        if (err && page !== 'awsmp') {
            uInfo.push({
                name: 'id',
                value: err
            })
            await pUserInfo(uInfo, process.env.REACT_APP_CONFIG_APP_FORM_ENDPOINT)
        }
    }

    function getUserOrgsSelectionValue (e) {
        if (userOrgs && userOrgs.data && userOrgs.data.length > 0) {
            const selectValue = userOrgs.data.find( org => org.selected === true)
            return selectValue && selectValue.value || null
        }
    }

    function getUserOrgsSelectionId (e) {
        if (userOrgs && userOrgs.data && userOrgs.data.length > 0) {
            const selectValue = userOrgs.data.find( org => org.selected === true)
            return selectValue && selectValue.id || null
        }
    }

    function getUserOrgsSelectionCode (e) {
        if (userOrgs && userOrgs.data && userOrgs.data.length > 0) {
            const selectValue = userOrgs.data.find( org => org.selected === true)
            return selectValue && selectValue.code || null
        }
    }

    function getUserOrgsSelectionLabel (e) {
        if (userOrgs && userOrgs.data && userOrgs.data.length > 0) {
            const selectValue = userOrgs.data.find( org => org.selected === true)
            return selectValue && selectValue.label || null
        }
    }

    function changeUserOrgsSelection (e) {
        const newOptions = userOrgs.data.map( option => {
            if (option.value === e) {
                option.selected = true
            } else {
                option.selected = false
            }
            return option
        })
        userOrgs.data = newOptions
        dispatch({ type: 'set-userOrgs', payload: { userOrgs: userOrgs } })
    }

    async function cancelAction() {
        analytics.sendEventName('click', `${page}:cancel`)
        setProjectNameErrorMsg(null)
        dispatch({ type: 'set-page', payload: { page: 'signup' } })
    }

    async function createCredentials() {
        try {
            const recaptchaResult = await runRecaptcha(ut)
            if (recaptchaResult.error) {
                error(`${__('msg_error_general')}`, {
                    timeout: TIMEOUT_TOAST_FAIL,
                    actionLabel: __('btn_go_to_console'),
                    onAction: (e) => goToUrlTarget(process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT, '_blank')
                })
                return
            }
            const { jobID, status } = await recaptchaResult.response.json();
            if (status !== "succeeded") {
                error(`${__('msg_error_general')}`, {
                    timeout: TIMEOUT_TOAST_FAIL,
                    actionLabel: __('btn_go_to_console'),
                    onAction: (e) => goToUrlTarget(process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT, '_blank')
                })
                logMsg(null, jobID)
                return
            }
            analytics.sendEventName('click', `${page}:createcredentials`)
            setProjectNameErrorMsg(null)
            dispatch({ type: 'wait', payload: true })

            const orgId = getUserOrgsSelectionId()
            const resCreateCredentials = await runCreateCredentialsServicePrincipal(projectName, orgId, ut, awsCustomerId)

            if (resCreateCredentials && resCreateCredentials.status && resCreateCredentials.status === STATUS_CODE_SUCCESS_CREATED) {
                analytics.sendEventName('api', `createcredentials:${resCreateCredentials.status}`)
                uInfo.push({
                    name: 'id',
                    value: resCreateCredentials.apiKey
                })
                if (page === 'awsmp') {
                    const orgCode = getUserOrgsSelectionCode()
                    const bodyObject = {
                        'customerId': awsCustomerId,
                        'orgId': orgCode,
                        'clientId': uInfo.find( u => u.name === 'id').value
                    }
                    await setAwsMarketplaceUser(ut, bodyObject)
                }
            } else {
                let statusCode = resCreateCredentials && resCreateCredentials.status || resCreateCredentials.response && resCreateCredentials.response.status
                if (!statusCode) {
                    statusCode = resCreateCredentials.message || 'fail'
                }
                if (statusCode === STATUS_CODE_FAIL_CONFLICT) {
                    setProjectNameErrorMsg(`  ${projectName} ${__('console_create_error_project_name')}`)
                } else {
                    logAlert(resCreateCredentials, statusCode)
                }
                analytics.sendEventName('api', `createcredentials:${statusCode}`)
                let errorMsg = resCreateCredentials && resCreateCredentials.response && resCreateCredentials.response.data && resCreateCredentials.response.data.messages && resCreateCredentials.response.data.messages.length > 0 && resCreateCredentials.response.data.messages[0] && resCreateCredentials.response.data.messages[0].message || resCreateCredentials && resCreateCredentials.message
                const xRequestId = resCreateCredentials && resCreateCredentials.response && resCreateCredentials.response.headers && resCreateCredentials.response.headers['x-request-id']
                uInfo.push({
                    name: 'id',
                    value: `FAILED: ${statusCode} ${errorMsg} (${xRequestId})`
                })
            }
            if (awsCustomerId) {
                uInfo.find( u => u.name === 'usecase').value = process.env.REACT_APP_CONFIG_APP_AWS_MP_ALTAS_PLAN_CODE
                uInfo.find( u => u.name === 'company-size').value = ''
            }
            await pUserInfo(uInfo, process.env.REACT_APP_CONFIG_APP_FORM_ENDPOINT)
            if (resCreateCredentials && resCreateCredentials.status && resCreateCredentials.status === STATUS_CODE_SUCCESS_CREATED) {
                dispatch({ type: 'set-cred', payload: { cred: resCreateCredentials } })
                dispatch({ type: 'set-page', payload: { page: 'credinfo' } })
            }
            dispatch({ type: 'wait', payload: false })
        } catch(e) {
            logAlert(e)
            dispatch({ type: 'wait', payload: false })
        }
    }

    function logAlert (e, statusCode) {
        let msg = e && e.response && e.response.data && e.response.data.messages && e.response.data.messages.length > 0 && e.response.data.messages[0] && e.response.data.messages[0].message || e && e.message
        if(!msg) {
            msg = `${__('msg_error_general')}`
        }
        if (statusCode) {
            switch (statusCode) {
                case STATUS_CODE_FAIL_LEGAL:
                    msg = `${__('msg_error_451')}${__('msg_error_space')}Please accept the terms for your organization in Console and try again.`
                    error(`${__('msg_error_space')}${msg} (statusCode: ${statusCode})`, {
                        timeout: TIMEOUT_TOAST_FAIL,
                        actionLabel: __('btn_go_to_console'),
                        onAction: (e) => goToUrlTarget(process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT, '_blank')
                    })
                    break;
                case STATUS_CODE_FAIL_FORBIDDEN:
                    error(`${__('msg_error_space')} ${msg}${__('msg_error_space')}(statusCode: ${statusCode})`, {
                        timeout: TIMEOUT_TOAST_FAIL,
                        actionLabel: __('btn_go_to_console'),
                        onAction: (e) => goToUrlTarget(process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT, '_blank')
                    })
                    break;
                default:
                    error(`${__('msg_error_space')}${msg}${__('msg_error_space')}${(__('msg_error_4xx'))} (statusCode: ${statusCode})`, {
                        timeout: TIMEOUT_TOAST_FAIL,
                        actionLabel: __('btn_submit_ticket'),
                        onAction: (e) => goToUrlTarget(__('url_zendesk_ticket_new'), '_blank')
                    })
                    break;
            }
        } else {
            error(`${__('msg_error_space')}${msg}`, {
                timeout: TIMEOUT_TOAST_FAIL,
                actionLabel: __('btn_go_to_console'),
                onAction: (e) => goToUrlTarget(process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT, '_blank')
            })
        }
    }

    function getSelectedValue(data) {
        const selected = data.filter( size => size.selected )
        return selected.length > 0 && selected[0].value || data[0].value
    }

    function changeProjectName (e) {
        setProjectNameErrorMsg(null)
        dispatch({ type: 'set-projectName', payload: { projectName: e.target.value } })
    }

    function isDisabled() {
        if (!ut) {
            return true
        }
        if (act && awsCustomerId) {
            if (awsCustomerClientId) {
                return true
            }
        }
        if (userOrgs && !userOrgs.status ||  userOrgs && userOrgs.status !== STATUS_CODE_SUCCESS_OK) {
            return true
        }
        if (userOrgs && userOrgs.data && userOrgs.data.length === 0) {
            return true
        }
        if (isProjectNameValid(projectName) || projectName === '' || projectName === null) {
            return true
        }
        if (userOrgs && userOrgs.data && userOrgs.data.length === 0 || userOrgs && userOrgs.data && userOrgs.data.filter( org => org.selected ).length === 0) {
            return true
        }
        if ((page !== 'awsmp') && !formDevTermsAgreement) {
            return true
        }
        return false
    }

    function isProjectNameValid(str) {
        try{
            if (str && str.length > 0 && !CONSOLE_PROJECT_NAME_PATTERN.test(str.trim())) {
                return __('signup_form_error_project_name_char')
            }
            if (!str || str === '' || str.length > 25 || str.length < 6) {
                return __('signup_form_error_project_name_length')
            }
            return null
        } catch(e) {
            console.log(e)
        }
    }

    return <div className="adobe-easybake-main-sub-pane">
        { wait && <div className="adobe-easybake-modal-loading">
            <Wait size="L" />
            <div>{__('console_creating_cred')}</div>
        </div>}
        <div>
            <div className="adobe-easybake-main-pane-console-content-left">
                <div className="adobe-easybake-main-sub-pane-header">
                    <ConsoleSteps referrer={page}/>
                    <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('console_credinfo_ps_api_service')}</Heading>
                    <br />
                </div>
                <div className="adobe-easybake-main-pane-console-content-left-content">
                    <div>
                        <div>
                            { !ut && <div>
                                <Alert  variant="error">
                                    {__('console_get_started_desc')} Please <a href="#" onClick={ e => signInClick(e) }>sign in</a> to continue.
                                </Alert>
                            </div> }
                            { awsCustomerClientId && <div>
                                <Alert  variant="info">
                                    {__('console_aws_client_id_found')}
                                </Alert>
                            </div> }
                        </div>
                        {/* <Heading variant="subtitle3" className="adobe-easybake-console-page-cred-subtitle-3">{__('console_photoshopapi_title')}</Heading> */}
                        <div className="adobe-easybake-flex-row">
                            <div className="adobe-easybake-credinfo-logo-create"><img src={Ps} alt="" className="sub-nav-icon" /></div>
                            <div>{__('console_credinfo_ps_api_service')}</div>
                        </div>
                        <p className="adobe-easybake-console-page-service-desc">{__('console_service_desc')}</p>
                        <Heading variant="subtitle3" className="adobe-easybake-console-page-cred-subtitle-3">{__('console_project_title')}</Heading>
                        <div className="adobe-easybake-flex-row adobe-easybake-form-create">
                            <FieldLabel necessity="required" label="Project Name" labelFor="tf-projectName">
                                <Textfield 
                                    disabled={!ut}
                                    validationState={isProjectNameValid(projectName) ? 'invalid' : 'valid'}
                                    defaultValue={projectName}
                                    onBlur={ e => { changeProjectName(e) } }
                                    label="projectname"
                                    maxLength={45}
                                    id="tf-projectName"/>
                                { isProjectNameValid(projectName) && <div className="adobe-easybake-form-help-text">{isProjectNameValid(projectName)}</div> || projectNameErrorMsg && <div className="adobe-easybake-form-help-text">{projectNameErrorMsg}</div>}
                            </FieldLabel>
                        </div>
                        <br />
                        { (userOrgs && userOrgs.data && userOrgs.data.length !== 1) &&
                            <div className="adobe-easybake-flex-row adobe-easybake-form-create">
                                <FieldLabel necessity="required" label="Organization" labelFor="tf-userOrgs">
                                    <Select
                                        aria-label="tf-userOrgs"
                                        required
                                        label="userOrgs"
                                        defaultValue={getUserOrgsSelectionValue()}
                                        placeholder={__('console_create_org_select_option')}
                                        onChange={ e => changeUserOrgsSelection(e) }
                                        disabled={ userOrgs && userOrgs.data && userOrgs.data.length===0}
                                        options={ userOrgs.data } />
                                    { (userOrgs && userOrgs.data && userOrgs.data.length===0) && <ErrorMsg />}
                                </FieldLabel>
                            </div>
                        }
                        { (ut && userOrgs && userOrgs.status && userOrgs.status !== STATUS_CODE_SUCCESS_OK) && <ErrorMsg />}
                        { (ut && userOrgs && userOrgs.message && userOrgs.status !== STATUS_CODE_SUCCESS_OK) && <ErrorMsg referrer={ {errorMsg: userOrgs.message}}/>}
                        <br />
                    { page !== 'awsmp' && <div className="adobe-easybake-form-check-multi">
                        <Checkbox
                            // validationState={formAgreement ? 'valid' : 'invalid'}
                            onChange={ e => dispatch({ type: 'set-formDevTermsAgreement', payload: { formDevTermsAgreement: e } }) }
                            defaultValue={formDevTermsAgreement}
                            style={{
                                fontSize: '14px'
                            }}
                            label={__('console_dev_terms_agreement')}
                            name="tf-agreement" />
                        <div className="adobe-easybake-form-check-multi-lines">
                            <Link className="adobe-easybake-nav-link checkbox-link" referrer={`console:${page}:devterms`} label={__('console_dev_terms_link')} url={__('url_dev_terms')} noBreak={true} />
                            <span className="adobe-easybake-space-left-right">and</span>
                            <Link className="adobe-easybake-nav-link" referrer={`console:${page}:privatepolicy`} label={__('signup_form_filed_label_prerelease_desk_link_pp')} url={__('url_signup_form_filed_label_PrivacyPolicy')} noBreak={true} />
                        </div>
                    </div>}
                    </div>
                    { dMode && <div>
                        <Well>
                        <div>Plan: { act ? process.env.REACT_APP_CONFIG_APP_AWS_MP_ALTAS_PLAN_CODE : 'PS_FREE_TRIAL' }</div>
                        <div>{ `userOrgs.data.length: ${userOrgs && userOrgs.data && userOrgs.data.length}` }</div>
                        <div>{ `awsCustomerId: ${awsCustomerId}` }</div>
                        <div>{ `awsProdCode: ${awsProdCode}` }</div>
                        <div>{ `awsCustomerClientId: ${awsCustomerClientId}` }</div>
                        <div>{ `formFullName: ${formFullName}` }</div>
                        <div>{ `formEmail: ${formEmail}` }</div>
                        </Well>
                    </div>}
                    <div className='adobe-easybake-flex-row-buttons'>
                        <Button disabled={!ut} quiet variant="primary" onClick={ e => cancelAction(e) }>{__('console_create_btn_cancel')}</Button>
                        <Button variant="cta" disabled={ isDisabled() } onClick={ e => acceptDevTerms() }>{__('console_create_btn_create')}</Button>
                    </div>
                    <div className="adobe-easybake-p">{__('signup_form_filed_label_prerelease_term')}
                        <Link className="adobe-easybake-nav-link" referrer={`console:${page}:learnmore`} label={__('signup_form_filed_label_prerelease_learn')} url={__('url_signup_form_filed_label_learn')} noBreak={true} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}
